import { useEffect } from 'react';
import Eyebrow from './Eyebrow';
import Button from './Button';
import { PRODUCER } from '../lib/producer';

// The "Contact Henry" modal, opened from a top-bar button on the client review
// page. Keeps Henry one tap away without a standing sidebar card eating space
// on the script. The error-state ContactLine (shown on 404/410/etc.) is a
// separate, untouched surface.
export default function ContactModal({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-ink-900/70 backdrop-blur-md flex items-center justify-center px-6 z-50 animate-fade-in"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-modal-title"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-card border border-line rounded-md p-8 shadow-flare-lg/30 animate-scale-in"
      >
        <Eyebrow accent>// Contact Henry</Eyebrow>
        <div className="flex items-start gap-4 mt-4">
          <span
            aria-hidden
            className="w-12 h-12 rounded-full bg-accent text-accent-fg font-display font-semibold text-[22px] flex items-center justify-center shrink-0"
          >
            {PRODUCER.initial}
          </span>
          <div className="min-w-0">
            <h2
              id="contact-modal-title"
              className="font-display font-bold text-[20px] leading-[1.2]"
            >
              {PRODUCER.name}{' '}
              <span className="text-faint font-normal text-[15px]">· {PRODUCER.role}</span>
            </h2>
            <p className="text-muted text-[14px] leading-[1.55] mt-2">
              I’m working directly with you on this script: no account managers, no ticket
              queue. Email is the quickest way to reach me.
            </p>
          </div>
        </div>

        <a
          href={`mailto:${PRODUCER.email}`}
          className="
            mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full font-semibold
            px-5 py-3 text-[14px] bg-accent text-accent-fg border border-accent
            hover:bg-accent-hover active:bg-accent-pressed
            transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]
            focus:outline-none focus-visible:shadow-focus
          "
        >
          Email Henry
        </a>
        <p className="text-muted text-[13px] text-center mt-3 break-all">{PRODUCER.email}</p>
        <p className="text-faint text-[12px] text-center mt-1">{PRODUCER.replyTime}</p>

        <div className="flex justify-end mt-6">
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
